<script>
import baseList from "@/views/components/base/baseList.vue";
import {Tag, Button} from "view-design";
import Vue from "vue";


export default {
  extends: baseList,
  components: {

  },
  data() {
    return {
      table: {
        mname: "nursing",
        key: "id",
        url: {
          list:"/admin/system/nursing/list"
        },

      },
      menus: [
        {
          label: "待转运",
          name: "PatientWork_await",
          auth: "system/PatientWork/await",
          badge: {mname: "workstate", scene: "1"},
        },
        {
          label: "转运中",
          name: "PatientWork_process",
          auth: "system/PatientWork/await",
          badge: {mname: "workstate", scene: "2"},
        },
        {
          label: "已完成",
          name: "PatientWork_completed",
          auth: "system/PatientWork/completed",
          // badge: {mname: "workstate", scene: "3"},
        },
      ],
      query: {
        state: 2,
      },
      actions: [

      ],
      filters: [
        {
          label: "创建时间",
          KeyEnter: this.search,
          name: "",
          value: "",
          type: "datetimerange",
        },
        {
          label: "护工姓名",
          KeyEnter: this.search,
          name: "maintainerName",
          value: "",
          type: "input",
        },
        {
          label: "病人姓名",
          KeyEnter: this.search,
          name: "patientName",
          value: "",
          type: "input",
        },
        {
          label: "患者所在科室",
          name: "department",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "护送到手术间",
          name: "department",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
      ],
      tableCols: [
        {
          title: "转运单号",
          key: "workNo",
          width: 150,
          align: "center",
          tooltip: "true",
        },
        {
          title: "护工姓名",
          minWidth: 100,
          align: "center",
          key: "nursingName",
          tooltip: "true",
        },
        {
          title: "病人姓名",
          key: "patientName",
          minWidth: 120,
          align: "center",
          tooltip: "true",
        },
        {
          title: "患者所在科室",
          key: "deskName",
          minWidth: 100,
          align: "center",
          tooltip: "true",
        },
        {
          title: "护送到手术间",
          key: "tranferDeskName",
          minWidth: 120,
          align: "center",
          tooltip: "true",
        },


        {
          title: "状态",
          key: "state",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.state === 1 ? "待转运" :row.state === 2 ? "转运中" :row.state === 3 ? "已完成" : "";
            return <span style={{"font-size": "14px"}}>{text}</span>;
          },
        },
        {
          title: "接单时间",
          minWidth: 60,
          align: "center",
          key: "orderTransferTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.orderReceivingTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
        {
          title: "创建时间",
          minWidth: 60,
          align: "center",
          key: "createTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.createTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },


        {
          title: "操作",
          align: "center",
          width: 190,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              // let directives = [];
              let directives = [
                {name: "auth", value: "system/workOrder/info"},
              ];
              return (
                  <Button
                      {...{directives}}
                      size="small"
                      onClick={() => this.toInfo(currentRow)}
                      type="default"
                      style={{
                        border: "none",
                        color: "#4991ff",
                      }}
                  >
                    详情
                  </Button>
              );
            },
          ],
        },
      ],
    };
  },
  created() {
  },
  methods: {
    //详情
    toInfo(row) {
      $utils.url.push({
        name: "PatientWork_info",
        query: {action: "edit", kv: row.id, workId: row.id},
      });
    },

  },
};
</script>
<style scoped>
</style>
